(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    define([], function(){ return factory(root); });
  } else if (typeof module === 'object' && module.exports) {
    module.exports = factory(globalThis || (typeof self !== 'undefined' ? self : this));
  } else {
    root.SwishFibaLinePack = factory(root);
  }
}(typeof self !== 'undefined' ? self : this, function (GLOBAL) {
  'use strict';

  function normHex(x){ if(!x) return '#FFFFFF'; x=String(x).trim(); if(x[0] !== '#') x='#'+x; return x.toUpperCase(); }

  (function ensureFibaLines(){
    if (GLOBAL && GLOBAL.SwishFibaLines) return;
    const config = GLOBAL && GLOBAL.SwishCBConfig;
    const create = config && config.createBasketballProceduralLineAPI;
    if (typeof create !== 'function') {
      try { console.error('[SwishFibaLines] procedural basketball helper unavailable'); } catch (_) {}
      GLOBAL.SwishFibaLines = {
        ready: Promise.resolve(),
        design: { W: 15000, L: 28000 },
        draw: function(){}
      };
      return;
    }
    GLOBAL.SwishFibaLines = create({
      rulesetId: 'FIBA',
      lengthM: 28,
      widthM: 15
    });
  })();

  function draw2D(ctx, x0, y0, cw, ch, color, opts) {
    if (GLOBAL.SwishFibaLines && typeof GLOBAL.SwishFibaLines.draw === 'function') {
      GLOBAL.SwishFibaLines.draw(ctx, x0, y0, cw, ch, normHex(color), Object.assign({ only: null, hideCenter: false }, opts || {}));
    }
  }

  function defaults() { return { length: 32, width: 19 }; }

  const linesApi = GLOBAL.SwishFibaLines || {};

  return {
    id: 'fiba.linepack',
    draw2D: draw2D,
    draw: draw2D,
    design: linesApi.design || { W: 15000, L: 28000 },
    ready: linesApi.ready || Promise.resolve(),
    defaults: defaults
  };
}));
